"use strict";import{IconDash300 as e}from"../src/elements/IconDash300.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-icon-dash300",e);
//# sourceMappingURL=sp-icon-dash300.js.map
